import { AvatarGroup } from '@mui/material';
import type { User } from 'app/collab/types';
import { useMemo } from 'react';
import styled from 'styled-components';
import { UserAvatar } from '../user-avatar/index.js';

const OverlappingAvatarGroup = styled(AvatarGroup)`
  margin-right: 2px;
  & > * {
    margin-right: -2px;
    box-shadow: 0 0 0 2px ${({ theme }) => theme.palette.background.paper};
  }
  & .MuiAvatarGroup-avatar {
    margin-left: 0;
    color: ${({ theme }) => theme.palette.primary.main};
    border: 2px solid;
    background-color: transparent;
    font-size: 0.9rem;
    font-weight: 500;
  }
`;

export type UserAvatarGroupProps = {
  readonly users: User[];
  readonly max?: number;
  readonly size?: number;
};

export function UserAvatarGroup({ users, max, size }: UserAvatarGroupProps) {
  const avatars = useMemo(
    () => users.map((user) => <UserAvatar key={user.id} user={user} size={size} />),
    [users, size]
  );

  return <OverlappingAvatarGroup max={Math.max(2, max ?? 2)}>{avatars}</OverlappingAvatarGroup>;
}
